import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { MART_PRODUCT_REQUEST_ID_LIST } from './martProduct-constant';

class MartProductServiceClass {
  postMartProductInquiry = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/products/inquiry',
      data: params.data,
      id: MART_PRODUCT_REQUEST_ID_LIST.POST_MART_PRODUCT_INQUIRY
    });
  }

  postMartProduct = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v2/merchant/company-admin/products',
      data: params.data,
      id: MART_PRODUCT_REQUEST_ID_LIST.POST_MART_PRODUCT
    });
  }

  patchMartProduct = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: 'v2/merchant/company-admin/products',
      data: params.data,
      id: MART_PRODUCT_REQUEST_ID_LIST.PATCH_MART_PRODUCT
    });
  }

  deleteMartProduct = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: 'v1/merchant/company-admin/products',
      config: {
        data: {
          productId: params.data,
        },
      },
      id: MART_PRODUCT_REQUEST_ID_LIST.DELETE_MART_PRODUCT
    });
  }

  getBasketLimit = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/products/basket-limit',
      id: MART_PRODUCT_REQUEST_ID_LIST.GET_BASKET_LIMIT
    });
  }

  postCalculateProductOrderLimitWeight = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/products/calculate-product-order-limit-weight',
      data: params.data,
      id: MART_PRODUCT_REQUEST_ID_LIST.POST_CALCULATE_PRODUCT_ORDER_LIMIT_WEIGHT
    });
  }

  postCalculateProductOrderLimitSize = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/products/calculate-product-order-limit-size',
      data: params.data,
      id: MART_PRODUCT_REQUEST_ID_LIST.POST_CALCULATE_PRODUCT_ORDER_LIMIT_SIZE
    });
  }
}

export const MartProductService = new MartProductServiceClass();
